import React, { useEffect } from "react";
import { Divider } from 'antd';
import PdfPageFrame from "../../components/PdfPageFrame";
import { useSelector } from "react-redux";


function CGUScreen() {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  useEffect(() => {
    document.body.style.overflowX = 'hidden';

    // Titre/description propres à la page pour le SEO (sinon Google retombe
    // sur le titre par défaut d'index.html et improvise le libellé du sitelink).
    const previousTitle = document.title;
    const descEl = document.querySelector('meta[name="description"]');
    const previousDescription = descEl ? descEl.getAttribute("content") : null;
    document.title = "Conditions Générales d'Utilisation | RAVAIL";
    if (descEl) descEl.setAttribute("content", "Conditions générales d'utilisation de la plateforme RAVAIL, l'outil d'aide au suivi de carrière et à la santé au travail.");

    return () => {
      document.body.style.overflowX = '';
      document.title = previousTitle;
      if (descEl && previousDescription !== null) descEl.setAttribute("content", previousDescription);
    };
  }, []);



  return (
    <>
      <div style={{ background: 'var(--vert-clair-nuance-5)', minHeight: '100vh' }}>
      <section className="section-3" style={{background: "none", paddingBottom: "64px", paddingTop: "2em"}}>
          <div className="page containerAccueil">
            <PdfPageFrame>
              <div id="pdfContent" style={{
                  position: 'relative', 
                  textAlign: 'justify', 
                  textJustify: "inter-word", 
                  width: 'auto',
                  fontSize: "14px", 
                  lineHeight: "1.5714285714285714",
                  fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'",
                  listStyle: "none",
                  padding: "20mm 20mm"
                }}
              >
                <h1 style={{marginTop: 0}}>Conditions Générales d’Utilisation (CGU)</h1>
                <p><strong>Version 1.0 du 23/11/2023</strong></p>

                <h3>1. Objet</h3>
                <p>
                    La Plateforme RAVAIL (ci-après la « Plateforme ») est un outil mis à disposition par les services de santé au travail (SST), avec l’assistance technique de RAVAIL en tant que sous-traitant. Elle a pour objectif de faciliter l’accès à certaines informations relatives à la santé au travail des salariés suivis par le SST.
                </p>
                <p>
                    Les salariés sont invités à répondre le plus précisément possible aux différentes questions de santé posées sur la Plateforme, afin de permettre aux professionnels de santé du SST de recommander le meilleur suivi médical possible pour leur situation spécifique.
                </p>

                <h3>2. Accès des salariés</h3>
                <p>
                    L’accès des salariés à la Plateforme se fait via un lien unique et sécurisé, délivré par le professionnel de santé. Ce lien expirera après avoir répondu aux questions de santé ou après un délai de 30 jours.
                </p>

                <h3>3. Restrictions d'utilisation</h3>
                <div>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Interdiction de reproduction et de copie :</strong> Il est strictement interdit de copier, reproduire, ou distribuer tout ou partie du contenu de la Plateforme, ainsi que d’en utiliser des éléments à des fins commerciales ou non autorisées.</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Interdiction de porter atteinte à l’intégrité de la Plateforme :</strong> Toute tentative de nuire à la sécurité, à la disponibilité ou à l’intégrité de la Plateforme, notamment par des attaques de type déni de service (DDoS), la transmission de logiciels malveillants ou toute autre action nuisible, est strictement interdite.</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Respect des droits de propriété intellectuelle :</strong> Les éléments de la Plateforme (textes, graphiques, logos, etc.) sont protégés par des droits de propriété intellectuelle et ne peuvent être utilisés sans autorisation préalable.</span>
                </div>

                <h3>4. Limites des informations fournies</h3>
                <p>
                    Les informations fournies peuvent évoluer en fonction des connaissances médicales et des recommandations en vigueur. En cas de doute, n'hésitez pas à poser la question à votre médecin du travail ou à votre SST.
                </p>

                <h3>5. Protection des données personnelles</h3>
                <p>
                    Les données des salariés sont traitées par RAVAIL en tant que sous-traitant, conformément au Règlement général sur la protection des données (RGPD) et à la Loi Informatique et Libertés. Les SST, en tant que responsables de traitement, sont chargés de veiller à la conformité de ces données. Les salariés peuvent exercer leurs droits sur leurs données personnelles directement auprès de leur SST.<br />
                    Les données collectées sont conservées de manière sécurisée en France sur un infrastructure et des serveurs certifiés Hébergeur de données de santé (HDS).
                </p>

                <h3>6. Responsabilité</h3>
                <p>
                    RAVAIL n’est pas responsable de la prise de décision médicale ou des évaluations individuelles ; celles-ci restent sous la responsabilité exclusive des professionnels de santé du SST. La responsabilité de RAVAIL est limitée aux services techniques, notamment pour assurer la sécurité et le bon fonctionnement de la Plateforme.
                </p>

                <h3>7. Loi applicable</h3>
                <p>
                    Les présentes CGU sont régies par le droit français. Tout litige sera soumis aux juridictions françaises compétentes.
                </p>
              </div>
            </PdfPageFrame>

            { userInfo && 
              <>
                <Divider/>
                <PdfPageFrame>
                  <div id="pdfContent" style={{
                      position: 'relative', 
                      textAlign: 'justify', 
                      textJustify: "inter-word", 
                      width: 'auto',
                      fontSize: "14px", 
                      lineHeight: "1.5714285714285714",
                      fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'",
                      listStyle: "none",
                      padding: "20mm 20mm"
                    }}
                  >
                    <h1 style={{marginTop: 0}}>Conditions d’utilisation spécifiques pour les professionnels de santé</h1>

                    <p><strong>Version 1.0 du 23/11/2023</strong></p>
                    <h3>1. Objet</h3>
                    <p>
                        Un compte personnel a été créé pour chaque professionnel de santé afin de faciliter l’accomplissement de ses missions en santé au travail pour les salariés suivis. Les informations liées à ce compte (nom, prénom, adresse e-mail, statut, droits d'accès) sont fournies par le service de santé au travail (SST), par un tiers autorisé ou par le professionnel de santé lui-même.
                    </p>

                    <h3>2. Engagements spécifiques</h3>
                    <div>
                        <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Respect de l’éthique médicale :</strong> Les professionnels de santé s’engagent à respecter les obligations déontologiques, notamment en matière de confidentialité et de secret médical. Toute utilisation non conforme au code de la déontologie médicale est interdite.</span>
                        <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Confidentialité renforcée :</strong> Les professionnels de santé doivent utiliser une authentification à double facteur pour garantir la sécurité des données des salariés. Ils sont responsables de la sécurisation de leurs identifiants.</span>
                        <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Notification des incidents de sécurité :</strong> En cas de suspicion d’incident de sécurité, le professionnel de santé est tenu d’en informer immédiatement RAVAIL et son SST pour garantir la confidentialité des données des salariés.</span>
                        <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Utilisation des informations scientifiques :</strong> La Plateforme intègre des informations scientifiques variées (réglementations, littérature, recommandations). Les professionnels de santé doivent valider et adapter ces informations à la situation de chaque salarié, en prenant en compte les spécificités individuelles et le contexte de travail réel du salarié.</span>
                        <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Responsabilité en cas de manquement :</strong> En cas de violation des présentes conditions, RAVAIL se réserve le droit de suspendre ou de révoquer l’accès à la Plateforme, avec notification au SST.</span>
                    </div>

                    <h3>3. Limitation de responsabilité supplémentaire</h3>
                    <p>
                        RAVAIL n'est pas responsable des décisions médicales prises par le professionnel de santé. La Plateforme est un outil de support, et les professionnels de santé sont seuls responsables de l'interprétation des informations fournies.
                    </p>
                  </div>
                </PdfPageFrame>
              </>
            }
          </div>
      </section>
      </div>
    </>
  );
}

export default CGUScreen;
